import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiZap, FiLogOut, FiSettings, FiUser, FiLock, FiUsers } = FiIcons;

const Header = ({ onShowSettings, onShowChangePassword, onShowUserManagement }) => {
  const { logout, currentUser } = useAuth();
  
  const isAdmin = currentUser?.role === 'admin';

  return (
    <header className="bg-electric-800 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <SafeIcon icon={FiZap} className="h-8 w-8 text-yellow-400" />
            <div>
              <h1 className="text-xl font-bold">True Potential Electric</h1>
              <p className="text-sm text-electric-200">Lead Management System</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <div className="hidden md:flex items-center bg-electric-700 rounded-lg px-3 py-1">
              <SafeIcon icon={FiUser} className="h-4 w-4 mr-2 text-electric-200" />
              <span className="text-sm">{currentUser?.username || 'User'}</span>
            </div>
            
            <button
              onClick={onShowChangePassword}
              className="p-2 rounded-lg hover:bg-electric-700 transition-colors"
              title="Change Password"
            >
              <SafeIcon icon={FiLock} className="h-5 w-5" />
            </button>
            
            {isAdmin && (
              <button
                onClick={onShowUserManagement}
                className="p-2 rounded-lg hover:bg-electric-700 transition-colors"
                title="User Management"
              >
                <SafeIcon icon={FiUsers} className="h-5 w-5" />
              </button>
            )}
            
            <button
              onClick={onShowSettings}
              className="p-2 rounded-lg hover:bg-electric-700 transition-colors"
              title="Settings"
            >
              <SafeIcon icon={FiSettings} className="h-5 w-5" />
            </button>
            
            <button
              onClick={logout}
              className="flex items-center space-x-2 px-4 py-2 bg-electric-700 hover:bg-electric-600 rounded-lg transition-colors"
            >
              <SafeIcon icon={FiLogOut} className="h-4 w-4" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;